module.exports = __webpack_public_path__ + "static/media/splash.6dec8547.png";